import { createAction, props } from '@ngrx/store';
import { OrderTicketType } from './user.state';
import { ContractViewerDetails } from 'src/app/pages/account/contract-viewer/models/contract.models';

/**
 * Logout the user and send them back to the login page.
 */
export const logout = createAction('[User] Logout');

/**
 * Clears the user. No routing involved
 */
export const clearUserAction = createAction('[User] Clear User');

/**
 * Set the user model
 */
export const paymentPortalResponse = createAction('[User] Payment Portal Response');

/**
 * Sets the membership to canceled
 */
export const setMembershipCanceledAction = createAction('[User] Cancel Membership');

/**
 * Sets the users MFA code
 */
export const setMfaCodeAction = createAction('[User] Set MFA Code', props<{ code: string; expiration: Date }>());

/**
 * Sets the users token code
 */
export const setUserTokenAction = createAction('[User] Set User Token', props<{ userToken: string }>());

/**
 * Starts MFA timer for session
 */
export const startTimerAction = createAction('[User] Start MFA session timer', props<{ isMFA: boolean }>());

/**
 * Stops MFA timer for session
 */
export const stopTimerAction = createAction('[User] Stop MFA session timer');

/**
 * Ends user session
 */
export const sessionEndedAction = createAction('[User] Session Ended - Log out');

/**
 * Updates UserState.isLockoutAccess to true if accessing portal with
 * configured lockout limited access
 */
export const isSessionLockoutAction = createAction(
	'[User] Session Lockout Access - Limited Access to User',
	props<{ isLockout: boolean }>()
);

export const updateUserIdTokenAction = createAction('[User] Update uidToken', props<{ uidToken: string }>());

export const updateUTTokenAction = createAction('[User] Update utToken', props<{ utToken: string }>());

/**
 * Called to update orderTicketTypes on user
 */
export const updateOrderTicketTypes = createAction('[User] Update orderTicketTypes', props<OrderTicketType>());

/**
 * Called to rebuild the MFA for the order when a user changes their email or phone
 */
export const rebuildMfaForOrder = createAction(
	'[Address Component] Rebuild MFA for Order',
	props<{
		oToken: string;
		eToken: string;
		pToken: string;
		mfa_code: string;
	}>()
);

export const rebuildMfaForOrderSuccess = createAction(
	'[API Effects] Rebuild MFA for Order Succeeded',
	props<{
		mfa_code: string;
		mfa_expiration: string;
	}>()
);

export const rebuildMfaForOrderFailure = createAction('[API Effects] Rebuild MFA for Order Failed');

export const openChangeUserEmailDialog = createAction('[API Effects] Open Change User Email Dialog');

export const openVerifyBarcodeDialog = createAction('[API Effects] Open Verify Barcode Dialog');

export const getOrderFormInfoSuccess = createAction(
	'[API Effects] Get Order Form Info Success',
	props<{ orderFormInfo: ContractViewerDetails }>()
);

export const changeUserEmailRequest = createAction(
	'[User Effects] Change User Email Request',
	props<{
		newEmail: string;
	}>()
);

export const changeUserEmailSuccess = createAction('[User Effects] Change User Email Success');

export const changeUserEmailFailed = createAction('[User Effects] Change User Email Failed');

/**
 * Used to indicate when guestViewOrder info is availble
 * for booking-portal/summary to render
 */
export const guestViewOrderComplete = createAction('[User Effects] Guest View Order', props<{ complete: boolean }>());
